module.exports = __webpack_public_path__ + "img/hil-logo-text.d45e6ab5.png";